import { rest } from "msw";
import type { RestHandler } from "msw";
import config from "../../config";
import { apiVersion } from "../../shared/constants/common.constant";

interface RechargeSummaryApiResponse {
  activeSchedulesCount: number;
  hasUnlimitedScreeningCredits: boolean;
  availableScreeningCredits: number;
  hasUnlimitedMonitoringCredits: boolean;
  availableMonitoringCredits: number;
  rechargeDueDate: string;
  minTopUpToRenew: number;
}

export const mockGetRechargeSummary = (
  rechargeData?: RechargeSummaryApiResponse,
  apiFailed = false
): RestHandler => {
  const originalUrl = `${config.COMPLIANCE_API_URL}/${apiVersion}/recharge/summary`;
  const defaultData: RechargeSummaryApiResponse = {
    activeSchedulesCount: 0,
    hasUnlimitedScreeningCredits: false,
    availableScreeningCredits: 1400,
    hasUnlimitedMonitoringCredits: true,
    availableMonitoringCredits: 0,
    rechargeDueDate: "2026-12-31T00:00:00Z",
    minTopUpToRenew: 0,
  };

  return rest.get(originalUrl, async (_, res, ctx) => {
    return res(
      apiFailed ? ctx.status(500) : ctx.status(200),
      ctx.json(rechargeData ?? defaultData)
    );
  });
};
